import { makeStyles } from 'tss-react/mui';

export const useVideoCallLayoutStyles = makeStyles()((theme) => ({
  container: {
    background: 'rgba(0, 0, 0, 0.87)',
    // Do not change - works in cordination with 100% minus the footer size, this is to prevent ios safari from having scroll issues.
    height: '100%',
    width: '100vw',
    display: 'flex',
    overflow: 'hidden',
  },
  mainParticipantContainer: {
    width: '100%',
    height: `calc(100% - ${theme.spacing(6)} - ${theme.spacing(2)})`,
    position: 'relative',
  },
  mainParticipant: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
  },
  participantsContainer: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1.5),

    minWidth: '125px',
    width: '23%',

    [theme.breakpoints.up('sm')]: {
      top: 0,
      right: 0,
    },

    [theme.breakpoints.up('md')]: {
      width: '15%'
    }
  },
  participant: {
    width: '100%',
    overflow: 'hidden'
  },
  controlPanelContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
  },
  tooltip: {
    // top: theme.spacing(-1),
    fontSize: '14px',
  },
  sidebarContainer: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    height: `calc(100% - ${theme.spacing(1)})`,
    display: 'flex',
  },
  sidebarItem: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: theme.spacing(0.5),
    color: theme.palette.common.white,
  },
  sidebarDrawer: {
    height: '100%',
  },
  drawerContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.common.white,
    height: '100%',
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
  },
  drawerContentContainerHeader: {
    height: theme.spacing(5.5),
    borderBottom: `2px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(0.5),
    background: theme.palette.common.white,
  },
}));
